import { SylPlugin } from '@syl-editor/core-utilities';
import BackgroundController from './controller';
import DIYBackground from './schema';

export default class LinkPlugin extends SylPlugin<any> {
  public name = 'diyBackground';

  public Controller = BackgroundController;

  public Schema = DIYBackground;
}
